module.exports = __webpack_public_path__ + "static/media/ticket.61b5d27e.png";